import { z } from 'zod';

import { translate } from '@front/i18n';

const t = translate('inputs');

export const firstNameSchema = z
  .string()
  .trim()
  .superRefine((value, ctx) => {
    if (!value) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: t('inputs.first_name.errors.required'),
      });
    } else if (value.length < 3) {
      ctx.addIssue({
        code: z.ZodIssueCode.too_small,
        inclusive: false,
        message: t('inputs.first_name.errors.too_short'),
        minimum: 3,
        type: 'string',
      });
    }
  });
